var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row mt-4 align-items-center\">\r\n  <label class=\"col-10 required\">When is the equipment required?</label>\r\n  <div class=\"col-2\">\r\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"DatePickerPartial"),depth0,{"name":"DatePickerPartial","hash":{"data-parsley-current-or-future-date":"true","required":"true","aria-label":"Equipment required date","name":"dateEquipmentReq"},"data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "  </div>\r\n</div>";
},"usePartial":true,"useData":true});